import { alpha, makeStyles, Theme } from "@material-ui/core"

const DRAWER_WIDTH = 200

export const useStyles = makeStyles((theme: Theme) => ({
  container: { display: "flex" },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    "& .MuiToolbar-root": {
      padding: theme.spacing(0, 1),
    },
  },
  content: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -DRAWER_WIDTH + 49,
    width: "calc(100vw - 49px)",
    overflow: "auto",
    padding: theme.spacing(1.5, 2),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1),
    },
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  drawerOpen: {
    width: DRAWER_WIDTH,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: 49,
  },
  logo: {
    height: 32,
    padding: theme.spacing(0.2, 0, 0.875, 0),
    marginRight: theme.spacing(2),
    "& img": {
      display: "block",
      height: "100%",
    },
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  appContext: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    "&  *": {
      color: theme.palette.common.white,
    },
    "& > div ": {
      backgroundColor: alpha(theme.palette.common.white, 0.1),
      borderRadius: theme.shape.borderRadius,
      marginRight: theme.spacing(1),
    },
  },
  drawer: {
    width: DRAWER_WIDTH,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    maxHeight: "48px !important",
    minHeight: "48px !important",
    color: theme.palette.common.white,
    marginTop: theme.spacing(),
  },
  navItem: {
    "& .MuiListItemText-root": {
      marginLeft: -theme.spacing(1),
      "& .MuiTypography-root": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontSize: 14,
      },
    },
    "& .chevronIcon": {
      marginRight: -theme.spacing(1.5),
    },
    "& .MuiListItemIcon-root svg, & .chevronIcon svg": {
      color: theme.palette.common.black,
      width: 20,
      height: 20,
    },
    "&.Mui-selected": {
      background: alpha(theme.palette.primary.main, 0.1),
      "& .MuiTypography-root": {
        fontWeight: 600,
        color: theme.palette.primary.main,
      },
      "& .MuiListItemIcon-root svg": {
        color: theme.palette.primary.main,
      },
    },
  },
  nested: {
    marginLeft: theme.spacing(7),
  },
  replacementDiv: {
    height: 48,
    width: "100%",
  },
}))
